import React, { useState } from "react";
import { X } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { toast } from "sonner";

export default function PreorderModal({ open, onClose, product }) {
  const { settings } = useSettings();
  const [form, setForm] = useState({ customer_name: "", phone: "", location: "" });
  const [submitting, setSubmitting] = useState(false);

  if (!open || !product) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.customer_name || !form.phone || !form.location) {
      toast.error("Veuillez remplir tous les champs");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/preorders", {
        product_id: product.id,
        product_name: product.name,
        customer_name: form.customer_name,
        phone: form.phone,
        location: form.location,
      });

      const number = settings?.whatsapp_number || "2250711693161";
      const msg = `Précommande Refuge de la Foi\n\nProduit : ${product.name}\nNom : ${form.customer_name}\nTéléphone : ${form.phone}\nLieu de livraison : ${form.location}`;
      window.open(`https://wa.me/${number}?text=${encodeURIComponent(msg)}`, "_blank");
      toast.success("Précommande enregistrée");
      onClose();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm px-4"
      data-testid="preorder-modal"
      onClick={onClose}
    >
      <div
        className="relative bg-white border border-[#B8860B]/30 w-full max-w-md p-8"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-[#6B6B6B] hover:text-[#B8860B]"
          data-testid="preorder-modal-close"
        >
          <X size={20} />
        </button>
        <h3 className="font-display text-2xl text-[#B8860B]">Précommander</h3>
        <p className="font-citation italic text-sm text-[#1A1A1A]/75 mt-3 leading-relaxed">
          {settings?.preorder_message ||
            "Cet article est actuellement en rupture de stock. Le délai minimum estimé est de 45 jours."}
        </p>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div>
            <label className="label-tiny block mb-1">Nom</label>
            <input
              className="input-gold"
              value={form.customer_name}
              onChange={(e) => setForm({ ...form, customer_name: e.target.value })}
              data-testid="preorder-name-input"
              required
            />
          </div>
          <div>
            <label className="label-tiny block mb-1">Téléphone</label>
            <input
              className="input-gold"
              value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })}
              data-testid="preorder-phone-input"
              required
            />
          </div>
          <div>
            <label className="label-tiny block mb-1">Lieu de livraison</label>
            <input
              className="input-gold"
              value={form.location}
              onChange={(e) => setForm({ ...form, location: e.target.value })}
              data-testid="preorder-location-input"
              required
            />
          </div>
          <button
            type="submit"
            className="btn-primary w-full"
            disabled={submitting}
            data-testid="preorder-submit-btn"
          >
            {submitting ? "Envoi..." : "Envoyer la précommande"}
          </button>
        </form>
      </div>
    </div>
  );
}
